import moment from 'moment-mini';

import { IPlaceholderResponse } from '@joc/api-gateway';

export enum PLACEHOLDER_PHASE {
	ACTIVE = 'ACTIVE',
	EXPIRED = 'EXPIRED',
	SCHEDULED = 'SCHEDULED',
}

export type PlaceholderPhaseSource = Pick<IPlaceholderResponse, 'startDate' | 'endDate'>;

export const getPlaceholderPhase = (placeholder: PlaceholderPhaseSource): PLACEHOLDER_PHASE | null => {
	if (!placeholder.startDate || !placeholder.endDate) {
		return null;
	}

	const now = moment();
	const start = moment(placeholder.startDate).startOf('day');
	const end = moment(placeholder.endDate).endOf('day');

	if (now.isAfter(end)) {
		return PLACEHOLDER_PHASE.EXPIRED;
	}

	if (now.isBefore(start)) {
		return PLACEHOLDER_PHASE.SCHEDULED;
	}

	return PLACEHOLDER_PHASE.ACTIVE;
};

export const isActivePlaceholder = (placeholder: PlaceholderPhaseSource): boolean =>
	getPlaceholderPhase(placeholder) === PLACEHOLDER_PHASE.ACTIVE;
